import { atom } from 'recoil';

export const isVendorsFilterModalOpenAtom = atom<boolean>({
  key: 'isVendorsFilterModalOpenState',
  default: false,
});
